import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAgents = (agents) => ({
  type: actionTypes.SET_AGENTS,
  payload: agents
})
